import { render } from "./TypeOfUsers.vue?vue&type=template&id=a56b245a"
import script from "./TypeOfUsers.vue?vue&type=script&lang=js"
export * from "./TypeOfUsers.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\front-api\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__